import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

var state = function state() {
  return {
    options: [],
    model: null,
    information: null,
    selectedOption: null,
    customizable: null,
    encodedCustomizable: null,
    oldCustomizable: null,
    configurator: false,
    price: null
  };
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};